import { Zap } from 'lucide-react'

import { Tooltip } from '~/components/component-library'

export const AutoEarnIndicator = () => {
  return (
    <Tooltip content="Autoearn is on">
      <div className="flex size-4 items-center justify-center rounded-full bg-blue-500">
        <Zap className="size-2.5 fill-white text-white" strokeWidth={2} />
      </div>
    </Tooltip>
  )
}
